<template>
  <div>
    <AllCases :insuranceExceptionFlag="true"></AllCases>
  </div>
</template>

<script>
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    AllCases,
  },
};
</script>
